import React, { Component } from "react";
import ContractChangeOrderForm from "./ContractChangeOrderForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class ContractChangeOrder extends Component {
  state = {
    proj_contract_change_order_id: null
  };

  componentDidMount() {
    this.props.contractChangeOrder.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <ContractChangeOrderForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentContractChangeOrder={
              this.state.proj_contract_change_order_id === null
                ? null
                : this.props.contractChangeOrder.contractChangeOrder.find(
                    contractChangeOrder =>
                      contractChangeOrder.proj_contract_change_order_id ===
                      this.state.proj_contract_change_order_id
                  )
            }
            update={this.props.contractChangeOrder.update}
            add={this.props.contractChangeOrder.add}
            projectID={this.props.currentProjectID}
          />
        </SmallModal>
      );
    }
    return (
      <div>
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              color={"blue"}
              className={"my-2"}
              onClick={() => {
                this.setState({ proj_contract_change_order_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Contract Change Order
            </Button>
          </div>
        )}
        {smallModal}

        <table className={"table"}>
          <thead>
            <tr>
              <th>Change Cost</th>
              <th>Change Date</th>
              <th>Change Order Name</th>
              <th>Content</th>
              {this.props.disabled ? null : <th>Delete</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.contractChangeOrder.contractChangeOrder.map(item => (
              <tr
                key={item.proj_contract_change_order_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      proj_contract_change_order_id:
                        item.proj_contract_change_order_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.change_cost}</td>
                <td>{item.change_date}</td>
                <td>{item.change_order_name}</td>
                <td>{item.content}</td>
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color="blue"
                      type="button"
                      onClick={() => {
                        this.setState({
                          proj_contract_change_order_id:
                            item.proj_contract_change_order_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      color="red"
                      type="button"
                      onClick={() =>
                        this.props.contractChangeOrder.delete(
                          item.proj_contract_change_order_id,
                          this.props.currentProjectID
                        )
                      }
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ContractChangeOrder;
